/**
 * 10Duke Entitlement API
 * 3.4.0
 * DO NOT MODIFY - This file has been generated using oazapfts.
 * See https://www.npmjs.com/package/oazapfts
 */
import * as Oazapfts from "oazapfts/lib/runtime";
import * as QS from "oazapfts/lib/runtime/query";
export const defaults: Oazapfts.RequestOpts = {
    baseUrl: "https://entitlement.10duke.com",
};
const oazapfts = Oazapfts.runtime(defaults);
export const servers = {
    server1: "https://entitlement.10duke.com"
};
export type ResourceBase = {
    /** The unique ID of the object. If an ID is not specified when the object is created, the system generates an ID. */
    id?: string;
};
export type ResourceBaseRead = {
    /** The unique ID of the object. If an ID is not specified when the object is created, the system generates an ID. */
    id?: string;
    /** The date and time (ISO 8601) when the object was created. */
    created?: string;
    /** The ID of the user who created the object. */
    authorId?: string;
    /** The date and time (ISO 8601) when the object was last modified. */
    modified?: string;
    /** The ID of the user who last modified the object. */
    editorId?: string;
};
export type LicensedItemReference = {
    /** The unique ID of the referenced licensed item. */
    id: string;
    /** The unique name of the referenced licensed item. */
    name?: string;
};
export type LicenseModelReference = {
    /** The unique ID of the referenced license model. */
    id: string;
    /** The unique name of the referenced license model. */
    name?: string;
};
export type ProductItem = ResourceBase & {
    licensedItem?: LicensedItemReference;
    licenseModel?: LicenseModelReference;
    /** The seat count granted in the license. */
    seatCount?: number;
    /** The seat reservation count allowed for the license. This is a multiplier for the license's seat count to calculate how many reservations are allowed in total. */
    seatReservationCount?: string;
    /** The use count granted in the license. */
    useCount?: number;
    /** The use time granted in the license. */
    useTime?: number;
    /** The client application versions allowed to consume the license. Depending on the version check policy defined in the license model, the format of this field can be an exact semantic version with the desired accuracy (such as "4.2.1"), a semantic version range with the desired accuracy (such as "4 - 5.1"), or a regular expression (such as "^2022-RC[1-9]$"). */
    allowedVersions?: string;
    /** A human-readable description of the allowed versions. */
    allowedVersionsDescription?: string;
};
export type ProductItemRead = ResourceBaseRead & {
    licensedItem?: LicensedItemReference;
    licenseModel?: LicenseModelReference;
    /** The seat count granted in the license. */
    seatCount?: number;
    /** The seat reservation count allowed for the license. This is a multiplier for the license's seat count to calculate how many reservations are allowed in total. */
    seatReservationCount?: string;
    /** The use count granted in the license. */
    useCount?: number;
    /** The use time granted in the license. */
    useTime?: number;
    /** The client application versions allowed to consume the license. Depending on the version check policy defined in the license model, the format of this field can be an exact semantic version with the desired accuracy (such as "4.2.1"), a semantic version range with the desired accuracy (such as "4 - 5.1"), or a regular expression (such as "^2022-RC[1-9]$"). */
    allowedVersions?: string;
    /** A human-readable description of the allowed versions. */
    allowedVersionsDescription?: string;
};
export type ProductItems = ProductItem[];
export type ProductItemsRead = ProductItemRead[];
export type ApiError = {
    /** The error code. */
    error: string;
    /** A human-readable error description. */
    error_description?: string;
    /** The URI where further information on the error is available. */
    error_uri?: string;
};
export type ResourceWithValidity = ResourceBase & {
    /** The start date and time (ISO 8601) from which the object is valid. If not specified or null, the object is not considered valid. */
    validFrom?: string;
    /** The end date and time (ISO 8601) after which the object expires. If not specified or null, the object is considered valid indefinitely. */
    validUntil?: string;
};
export type ResourceWithValidityRead = ResourceBaseRead & {
    /** The start date and time (ISO 8601) from which the object is valid. If not specified or null, the object is not considered valid. */
    validFrom?: string;
    /** The end date and time (ISO 8601) after which the object expires. If not specified or null, the object is considered valid indefinitely. */
    validUntil?: string;
};
export type Product = ResourceWithValidity & {
    /** The name of the product package. */
    name?: string;
    /** The description of the product package. */
    description?: string;
    /** Indicates if the product package is active. If this is "true" or not specified, the product package is considered active. */
    active?: boolean;
};
export type ProductRead = ResourceWithValidityRead & {
    /** The name of the product package. */
    name?: string;
    /** The description of the product package. */
    description?: string;
    /** Indicates if the product package is active. If this is "true" or not specified, the product package is considered active. */
    active?: boolean;
};
export type Products = Product[];
export type ProductsRead = ProductRead[];
export type LicenseProvisioningRequest = object;
export type LicenseContractReference = {
    /** The type of the contract, such as a subscription. If a value is not specified, the system assigns a default value. */
    "type": string;
    /** The external identifier of the contract in the client system. If an ID is not specified, the system sets the value to either the organization ID or the user ID, depending on the license owner. */
    externalContractId: string;
};
export type LicensedItems = LicensedItem[];
export type LicensedItemsRead = LicensedItem[];
export type LicensedItem = ResourceBase & {
    /** The unique name of the licensed item. This is used when checking licenses. */
    name?: string;
    /** The human-readable name of the licensed item. */
    displayName?: string;
    /** The description of the licensed item. */
    description?: string;
    /** The type of the licensed item. This can be used as additional metadata for grouping licensed items. */
    "type"?: string;
    /** The aggregated licensed items included in the parent licensed item. */
    aggregatedItems?: LicensedItems;
};
export type LicensedItemRead = ResourceBaseRead & {
    /** The unique name of the licensed item. This is used when checking licenses. */
    name?: string;
    /** The human-readable name of the licensed item. */
    displayName?: string;
    /** The description of the licensed item. */
    description?: string;
    /** The type of the licensed item. This can be used as additional metadata for grouping licensed items. */
    "type"?: string;
    /** The aggregated licensed items included in the parent licensed item. */
    aggregatedItems?: LicensedItemsRead;
};
export type LicenseCreditConsumptionSettingsBase = {
    /** The allowed over-usage to extend the license's seat count, use time, or use count. This can be either a specific amount of credit (such as the number of extra seats allowed) or a percentage of the credit. */
    allowedOveruse?: string;
    /** The type of credit in the license. */
    "type": string;
};
export type SeatConsumptionSettings = {
    "type": "seatCount";
} & LicenseCreditConsumptionSettingsBase;
export type UseCountConsumptionSettings = {
    "type": "useCount";
} & LicenseCreditConsumptionSettingsBase & {
    /** Indicates how use count is consumed from the license. */
    mode?: "callerProvidedCount";
};
export type UseTimeConsumptionSettings = {
    "type": "useTime";
} & LicenseCreditConsumptionSettingsBase;
export type LicenseCreditConsumptionSettings = SeatConsumptionSettings | UseCountConsumptionSettings | UseTimeConsumptionSettings;
export type LicenseAssignmentConstraints = {
    /** The types of license assignment anchors. This currently always returns "user". */
    anchors?: ("user" | "device")[];
    /** The requirement for seat reservations. "advance" = the license consumer needs an existing seat reservation to consume the license, "lazy" = a seat reservation is automatically created the first time the license consumer consumes the license, "optional" = the license model uses floating seats and seat reservations are optional. */
    reservations?: "advance" | "lazy" | "optional";
    /** The restrictions on reassigning reserved seats. "unlimited" = unlimited seat reassignments are allowed, "limited" = reserved seats can only be reassigned for a limited number of times, "prohibited" = seat reservations cannot be reassigned. */
    reassignments?: "unlimited" | "limited" | "prohibited";
    /** The maximum number of seat reassignments allowed for the license, if limited reassignments are allowed. */
    maxCount?: number;
};
export type ModeSpecificLicenseSessionConstraints = {
    /** The number of concurrent license sessions allowed per license seat. */
    maxCount?: number;
};
export type TotalLicenseSessionConstraints = {
    /** The total number of concurrent license sessions allowed per license seat. */
    maxCount?: number;
};
export type LicenseSessionConstraints = {
    /** The types of session anchors. */
    anchors?: ("device" | "resource")[];
    /** The constraints for license sessions in online consumption. */
    online?: ModeSpecificLicenseSessionConstraints;
    /** The constraints for license sessions in offline consumption. */
    offline?: ModeSpecificLicenseSessionConstraints;
    /** The total session constraints for all license consumption sessions. */
    total?: TotalLicenseSessionConstraints;
};
export type LeaseExtensionConstraints = {
    /** Indicates if extending a lease (lease chaining) is allowed. */
    allowed?: boolean;
    /** The authorization required to extend a lease. "leaseId" = the previous lease's lease ID must be provided, "optionalLeaseId" = the lease ID can be provided but is not required, "none" = the lease ID is ignored if provided. */
    authorization?: "leaseId" | "optionalLeaseId" | "none";
};
export type LeaseReleaseConstraints = {
    /** Indicates if releasing a license lease is allowed. */
    allow?: boolean;
    /** The cooldown period in milliseconds after releasing a lease, during which the lease is considered active and the license is not available to other license consumers. */
    cooldown?: number;
};
export type ModeSpecificLicenseLeaseConstraints = {
    /** The maximum lease time allowed in milliseconds. */
    maxLeaseTime?: number;
    extension?: LeaseExtensionConstraints;
    release?: LeaseReleaseConstraints;
};
export type LicenseLeaseConstraints = {
    /** The types of the lease anchors. */
    anchors?: "process"[];
    /** The constraints for license leases in online consumption. */
    online?: ModeSpecificLicenseLeaseConstraints;
    /** The constraints for license leases in offline consumption. */
    offline?: ModeSpecificLicenseLeaseConstraints;
};
export type ConsumptionLockConstraint = {
    /** The type of anchor to anchor consumption to. */
    lockAnchor?: "device";
};
export type LicenseConsumptionConstraints = {
    locking?: ConsumptionLockConstraint;
};
export type LicenseModel = ResourceBase & {
    /** The name of the license model. */
    name?: string;
    /** The description of the license model. */
    description?: string;
    credits?: LicenseCreditConsumptionSettings;
    assignments?: LicenseAssignmentConstraints;
    sessions?: LicenseSessionConstraints;
    leases?: LicenseLeaseConstraints;
    /** The setting for locking when consuming the license. "exclusive" = locking is enabled, which prevents overuse by race condition but may have a small negative impact on performance, "none" locking is disabled, in which case it cannot be guaranteed that license constraints are always correctly applied. */
    locking?: "none" | "exclusive";
    /** The version constraint. "constrain" = license consumption is restricted based on the software versions specified in the license, "allowAll" = no restrictions based on the software version. */
    versions?: "allowAll" | "constrain";
    consumption?: LicenseConsumptionConstraints;
};
export type LicenseModelRead = ResourceBaseRead & {
    /** The name of the license model. */
    name?: string;
    /** The description of the license model. */
    description?: string;
    credits?: LicenseCreditConsumptionSettings;
    assignments?: LicenseAssignmentConstraints;
    sessions?: LicenseSessionConstraints;
    leases?: LicenseLeaseConstraints;
    /** The setting for locking when consuming the license. "exclusive" = locking is enabled, which prevents overuse by race condition but may have a small negative impact on performance, "none" locking is disabled, in which case it cannot be guaranteed that license constraints are always correctly applied. */
    locking?: "none" | "exclusive";
    /** The version constraint. "constrain" = license consumption is restricted based on the software versions specified in the license, "allowAll" = no restrictions based on the software version. */
    versions?: "allowAll" | "constrain";
    consumption?: LicenseConsumptionConstraints;
};
export type EffectiveLicenseModel = LicenseModel;
export type EffectiveLicenseModelRead = LicenseModelRead;
export type LicenseScope = {
    /** The type of the scope, such as "hw" or "project". */
    "type"?: string;
    /** The external scope identifier provided by the client. */
    externalId?: string;
    /** The external scope name. */
    externalName?: string;
};
export type LicenseScopes = LicenseScope[];
export type LicenseScopesRead = LicenseScope[];
export type License = ResourceWithValidity & {
    /** Indicates if the license is active. If this is "true" or not specified, the license is considered active. */
    active?: boolean;
    /** The ID of the entitlement that contains the license. */
    entitlementId?: string;
    licensedItem?: LicensedItem;
    /** The ID of the license model used by the license. */
    licenseModelId?: string;
    /** The name of the license model used by the license. */
    licenseModelName?: string;
    effectiveLicenseModel?: EffectiveLicenseModel;
    scopeBindings?: LicenseScopes;
    /** The number of seats in use: seats that are either being consumed or that have a seat reservation. */
    seatsTaken?: number;
    /** The number of seats that have a seat reservation. */
    seatsReserved?: number;
    /** The total number of seats granted in the license. */
    seatsTotal?: number;
    /** The amount of use count consumed from the license. */
    useCountConsumed?: number;
    /** The total amount of use count granted in the license. If null, the license has an unlimited use count. */
    useCountTotal?: number;
    /** The amount of use time consumed from the license. */
    useTimeConsumed?: number;
    /** The total amount of use time in the license. If null, the license has unlimited use time. */
    useTimeTotal?: number;
    /** The identifier of the lock scope. */
    lockScope?: string;
    /** The properties of the license. Each property is defined as a name-value pair where the values are strings. */
    properties?: {
        [key: string]: string;
    };
};
export type LicenseRead = ResourceWithValidityRead & {
    /** Indicates if the license is active. If this is "true" or not specified, the license is considered active. */
    active?: boolean;
    /** The ID of the entitlement that contains the license. */
    entitlementId?: string;
    licensedItem?: LicensedItemRead;
    /** The ID of the license model used by the license. */
    licenseModelId?: string;
    /** The name of the license model used by the license. */
    licenseModelName?: string;
    effectiveLicenseModel?: EffectiveLicenseModelRead;
    scopeBindings?: LicenseScopesRead;
    /** The number of seats in use: seats that are either being consumed or that have a seat reservation. */
    seatsTaken?: number;
    /** The number of seats that have a seat reservation. */
    seatsReserved?: number;
    /** The total number of seats granted in the license. */
    seatsTotal?: number;
    /** The amount of use count consumed from the license. */
    useCountConsumed?: number;
    /** The total amount of use count granted in the license. If null, the license has an unlimited use count. */
    useCountTotal?: number;
    /** The amount of use time consumed from the license. */
    useTimeConsumed?: number;
    /** The total amount of use time in the license. If null, the license has unlimited use time. */
    useTimeTotal?: number;
    /** The identifier of the lock scope. */
    lockScope?: string;
    /** The properties of the license. Each property is defined as a name-value pair where the values are strings. */
    properties?: {
        [key: string]: string;
    };
};
export type LicenseCreditBase = ResourceWithValidity & {
    /** Indicates if the credit can be used for consuming the license. If not specified or null, the credit is considered active. */
    active?: boolean;
    /** The ID of the license for which credit is granted. */
    licenseId?: string;
    /** The ID of the license transaction item that granted the credit. */
    licenseTransactionItemId?: string;
};
export type LicenseCreditBaseRead = ResourceWithValidityRead & {
    /** Indicates if the credit can be used for consuming the license. If not specified or null, the credit is considered active. */
    active?: boolean;
    /** The ID of the license for which credit is granted. */
    licenseId?: string;
    /** The ID of the license transaction item that granted the credit. */
    licenseTransactionItemId?: string;
};
export type VersionConstrainedScopedLicenseCreditBase = LicenseCreditBase & {
    /** The client application versions allowed to consume the license. Depending on the version check policy defined in the license model, the format of this field can be an exact semantic version with the desired accuracy (such as "4.2.1"), a semantic version range with the desired accuracy (such as "4 - 5.1"), or a regular expression (such as "^2022-RC[1-9]$"). */
    allowedVersions?: string;
    /** A human-readable description of the allowed versions. */
    allowedVersionsDescription?: string;
    scopeBindings?: LicenseScopes;
};
export type VersionConstrainedScopedLicenseCreditBaseRead = LicenseCreditBaseRead & {
    /** The client application versions allowed to consume the license. Depending on the version check policy defined in the license model, the format of this field can be an exact semantic version with the desired accuracy (such as "4.2.1"), a semantic version range with the desired accuracy (such as "4 - 5.1"), or a regular expression (such as "^2022-RC[1-9]$"). */
    allowedVersions?: string;
    /** A human-readable description of the allowed versions. */
    allowedVersionsDescription?: string;
    scopeBindings?: LicenseScopesRead;
};
export type SeatCountCredit = VersionConstrainedScopedLicenseCreditBase & {
    /** The number of seats granted. */
    seatCount?: number;
    /** The number of seats currently being consumed. */
    seatsConsumed?: number;
};
export type SeatCountCreditRead = VersionConstrainedScopedLicenseCreditBaseRead & {
    /** The number of seats granted. */
    seatCount?: number;
    /** The number of seats currently being consumed. */
    seatsConsumed?: number;
};
export type SeatCountCredits = SeatCountCredit[];
export type SeatCountCreditsRead = SeatCountCreditRead[];
export type SeatReservationCredit = LicenseCreditBase & {
    /** The number of seat reservations (including seat reassignments) allowed for the license. */
    seatReservationCount?: number;
    /** The number of seat reservations (including seat reassignments) that have been made for the license. */
    seatReservationsConsumed?: number;
};
export type SeatReservationCreditRead = LicenseCreditBaseRead & {
    /** The number of seat reservations (including seat reassignments) allowed for the license. */
    seatReservationCount?: number;
    /** The number of seat reservations (including seat reassignments) that have been made for the license. */
    seatReservationsConsumed?: number;
};
export type SeatReservationCredits = SeatReservationCredit[];
export type SeatReservationCreditsRead = SeatReservationCreditRead[];
export type UseCountCredit = VersionConstrainedScopedLicenseCreditBase & {
    /** The use count granted. */
    useCount?: number;
    /** The use count that has been consumed. */
    countUsed?: number;
};
export type UseCountCreditRead = VersionConstrainedScopedLicenseCreditBaseRead & {
    /** The use count granted. */
    useCount?: number;
    /** The use count that has been consumed. */
    countUsed?: number;
};
export type UseCountCredits = UseCountCredit[];
export type UseCountCreditsRead = UseCountCreditRead[];
export type UseTimeCredit = VersionConstrainedScopedLicenseCreditBase & {
    /** The use time granted, in milliseconds. */
    useTime?: number;
    /** The use time that has been consumed. */
    timeUsed?: number;
};
export type UseTimeCreditRead = VersionConstrainedScopedLicenseCreditBaseRead & {
    /** The use time granted, in milliseconds. */
    useTime?: number;
    /** The use time that has been consumed. */
    timeUsed?: number;
};
export type UseTimeCredits = UseTimeCredit[];
export type UseTimeCreditsRead = UseTimeCreditRead[];
export type LicenseWithCredits = License & {
    seatCountCredits?: SeatCountCredits;
    seatReservationCredits?: SeatReservationCredits;
    useCountCredits?: UseCountCredits;
    useTimeCredits?: UseTimeCredits;
};
export type LicenseWithCreditsRead = LicenseRead & {
    seatCountCredits?: SeatCountCreditsRead;
    seatReservationCredits?: SeatReservationCreditsRead;
    useCountCredits?: UseCountCreditsRead;
    useTimeCredits?: UseTimeCreditsRead;
};
export type LicensesWithCredits = LicenseWithCredits[];
export type LicensesWithCreditsRead = LicenseWithCreditsRead[];
export type LicenseTransactionItem = ResourceBase & {
    /** The external identifier of the transaction item in the client system, such as an order line number. */
    externalId?: string;
    /** The ID of the product package. Provide either "productId" or "productName". Both cannot be provided in the same transaction item. */
    productId?: string;
    /** The name of the product package. Provide either "productName" or "productId". Both cannot be provided in the same transaction item. */
    productName?: string;
    /** The number of product packages requested, used for calculating the final license credit. This number is effectively a multiplier for the credit amount defined for the licensed item in the product package. */
    quantity?: number;
    /** The identifier for the scope within which to lock the hardware used for this license. Use "None" to override the license model settings and disable locking. */
    lockScope?: string;
    /** The validity start date and time (ISO 8601) for the licenses. */
    licenseValidFrom?: string;
    /** The validity end date and time (ISO 8601) for the licenses. If not specified or null, the licenses will be perpetual (valid indefinitely). */
    licenseValidUntil?: string;
    /** The licenses updated by this transaction item. */
    licenses?: LicensesWithCredits;
    /** The properties for the licenses. Each property is defined as a name-value pair where the values are strings. If not specified, null, or empty, no properties are created for the licenses. */
    licenseProperties?: {
        [key: string]: string;
    };
    /** The ID of the entitlement where to store the granted licenses. In a transaction update, this only affects where new licenses are stored, existing licenses are not moved. If not specified or null, the default entitlement is used. */
    entitlementId?: string;
};
export type LicenseTransactionItemRead = ResourceBaseRead & {
    /** The external identifier of the transaction item in the client system, such as an order line number. */
    externalId?: string;
    /** The ID of the product package. Provide either "productId" or "productName". Both cannot be provided in the same transaction item. */
    productId?: string;
    /** The name of the product package. Provide either "productName" or "productId". Both cannot be provided in the same transaction item. */
    productName?: string;
    /** The number of product packages requested, used for calculating the final license credit. This number is effectively a multiplier for the credit amount defined for the licensed item in the product package. */
    quantity?: number;
    /** The identifier for the scope within which to lock the hardware used for this license. Use "None" to override the license model settings and disable locking. */
    lockScope?: string;
    /** The validity start date and time (ISO 8601) for the licenses. */
    licenseValidFrom?: string;
    /** The validity end date and time (ISO 8601) for the licenses. If not specified or null, the licenses will be perpetual (valid indefinitely). */
    licenseValidUntil?: string;
    /** The licenses updated by this transaction item. */
    licenses?: LicensesWithCreditsRead;
    /** The properties for the licenses. Each property is defined as a name-value pair where the values are strings. If not specified, null, or empty, no properties are created for the licenses. */
    licenseProperties?: {
        [key: string]: string;
    };
    /** The ID of the entitlement where to store the granted licenses. In a transaction update, this only affects where new licenses are stored, existing licenses are not moved. If not specified or null, the default entitlement is used. */
    entitlementId?: string;
};
export type LicenseTransaction = ResourceBase & {
    /** The type of the transaction, such as Order, SubscriptionRenew, CodeActivation, or Trial. */
    "type"?: string;
    /** The external identifier of the transaction in the client system, such as an order number. The ID must be unique in 10Duke Enterprise. */
    externalId?: string;
    /** The client-provided or system-generated date and time (ISO 8601) when the transaction was processed. */
    processed?: string;
    contract?: LicenseContractReference;
    items?: LicenseTransactionItem[];
};
export type LicenseTransactionRead = ResourceBaseRead & {
    /** The type of the transaction, such as Order, SubscriptionRenew, CodeActivation, or Trial. */
    "type"?: string;
    /** The external identifier of the transaction in the client system, such as an order number. The ID must be unique in 10Duke Enterprise. */
    externalId?: string;
    /** The client-provided or system-generated date and time (ISO 8601) when the transaction was processed. */
    processed?: string;
    /** The date and time (ISO 8601) when the licenses of the transaction were suspended. This is null if the licenses are active. */
    cancelled?: string;
    contract?: LicenseContractReference;
    items?: LicenseTransactionItemRead[];
};
export type LicenseTransactionRequest = LicenseProvisioningRequest & {
    transaction?: LicenseTransaction;
};
export type LicenseTransactionRequestRead = LicenseProvisioningRequest & {
    transaction?: LicenseTransactionRead;
};
export type LicenseProvisioningResult = object;
export type LicenseTransactionProcessingResult = LicenseProvisioningResult & {
    transaction?: LicenseTransaction;
};
export type LicenseTransactionProcessingResultRead = LicenseProvisioningResult & {
    transaction?: LicenseTransactionRead;
};
export type LicenseRevokeResult = object;
export type SuspendLicensesOfTransactionResult = LicenseRevokeResult & {
    transaction?: LicenseTransaction;
};
export type SuspendLicensesOfTransactionResultRead = LicenseRevokeResult & {
    transaction?: LicenseTransactionRead;
};
export type ResumeLicensesOfTransactionResult = {
    transaction?: LicenseTransaction;
};
export type ResumeLicensesOfTransactionResultRead = {
    transaction?: LicenseTransactionRead;
};
export type Entitlement = ResourceBase & {
    /** The type of the entitlement. */
    "type"?: string;
    /** The name of the entitlement. */
    name?: string;
    /** The description of the entitlement. */
    description?: string;
    /** Indicates if this is the default entitlement for new licenses. */
    isDefault?: boolean;
};
export type EntitlementRead = ResourceBaseRead & {
    /** The type of the entitlement. */
    "type"?: string;
    /** The name of the entitlement. */
    name?: string;
    /** The description of the entitlement. */
    description?: string;
    /** Indicates if this is the default entitlement for new licenses. */
    isDefault?: boolean;
};
export type OrganizationGroup = ResourceBase & {
    /** The ID of the organization that owns the user group. */
    organizationId?: string;
    /** The name of the user group. */
    name?: string;
    /** The type of the user group. */
    "type"?: string;
    /** The description of the user group. */
    description?: string;
};
export type OrganizationGroupRead = ResourceBaseRead & {
    /** The ID of the organization that owns the user group. */
    organizationId?: string;
    /** The name of the user group. */
    name?: string;
    /** The type of the user group. */
    "type"?: string;
    /** The description of the user group. */
    description?: string;
};
export type ObjectIds = string[];
export type ClientGroup = ResourceBase & {
    /** The ID of the organization that owns the client group. */
    organizationId?: string;
    /** The name of the client group. */
    name?: string;
    /** The type of the client group. */
    "type"?: string;
    /** The description of the client group. */
    description?: string;
};
export type ClientGroupRead = ResourceBaseRead & {
    /** The ID of the organization that owns the client group. */
    organizationId?: string;
    /** The name of the client group. */
    name?: string;
    /** The type of the client group. */
    "type"?: string;
    /** The description of the client group. */
    description?: string;
};
export type UserIdentityBase = ResourceBase & {
    /** The user's full name as it should be displayed, possibly including a title and suffixes. */
    displayName?: string;
};
export type UserIdentityBaseRead = ResourceBaseRead & {
    /** The user's full name as it should be displayed, possibly including a title and suffixes. */
    displayName?: string;
};
export type LicenseeBase = ResourceBase & {
    /** The type of the license owner. */
    objectType?: string;
};
export type LicenseeBaseRead = ResourceBaseRead & {
    /** The type of the license owner. */
    objectType?: string;
};
export type LicenseConsumerBase = ResourceBase & {
    /** The type of the license consumer. */
    objectType?: string;
};
export type LicenseConsumerBaseRead = ResourceBaseRead & {
    /** The type of the license consumer. */
    objectType?: string;
};
export type UserProfile = UserIdentityBase & LicenseeBase & LicenseConsumerBase & {
    /** The user's primary contact email address. */
    email?: string;
    /** The user's first name. */
    firstName?: string;
    /** The user's last name. */
    lastName?: string;
    /** The start date and time (ISO 8601) from which the user's account is valid. */
    validFrom?: string;
    /** The end date and time (ISO 8601) after which the user's account is no longer valid. */
    validUntil?: string;
    /** The user's nickname. */
    nickname?: string;
    /** The user's phone number. */
    phoneNumber?: string;
    /** The user's professional title or status that describes their professional credentials (such as "Dr.") or their position in their organization (such as "CEO"). */
    professionalTitle?: string;
};
export type UserProfileRead = UserIdentityBaseRead & LicenseeBaseRead & LicenseConsumerBaseRead & {
    /** The user's primary contact email address. */
    email?: string;
    /** The user's first name. */
    firstName?: string;
    /** The user's last name. */
    lastName?: string;
    /** The start date and time (ISO 8601) from which the user's account is valid. */
    validFrom?: string;
    /** The end date and time (ISO 8601) after which the user's account is no longer valid. */
    validUntil?: string;
    /** The date and time (ISO 8601) of the user's last login. */
    lastSignOn?: string;
    /** The user's nickname. */
    nickname?: string;
    /** The URL where the user's profile picture is located. */
    picture?: string;
    /** The user's phone number. */
    phoneNumber?: string;
    /** The user's professional title or status that describes their professional credentials (such as "Dr.") or their position in their organization (such as "CEO"). */
    professionalTitle?: string;
};
export type LicenseAssignment = ResourceWithValidity & {
    /** The type of the license assignment. "reserved" = a seat reservation for the license, "denied" = a blocking from using the license, "floating" = a temporary reservation (for example, the user or client is consuming a seat from a floating pool) that is deleted when the license session ends. */
    "type"?: "reserved" | "denied" | "floating";
};
export type LicenseAssignmentRead = ResourceWithValidityRead & {
    /** The type of the license assignment. "reserved" = a seat reservation for the license, "denied" = a blocking from using the license, "floating" = a temporary reservation (for example, the user or client is consuming a seat from a floating pool) that is deleted when the license session ends. */
    "type"?: "reserved" | "denied" | "floating";
};
export type ExternalEntityReference = {
    /** The type of the anchor. */
    "type": string;
    /** The external ID of the anchor. */
    externalId: string;
    /** The external name of the anchor. */
    externalName?: string;
};
export type LicenseLeaseAnchor = ExternalEntityReference;
export type LicenseLeaseAnchors = LicenseLeaseAnchor[];
export type LicenseLeaseAnchorsRead = LicenseLeaseAnchor[];
export type LicenseLease = ResourceWithValidity & {
    /** The lease consumption mode, online or offline. */
    mode?: "Online" | "Offline";
    /** The software application version provided in the license consumption request. */
    version?: string;
    anchors?: LicenseLeaseAnchors;
};
export type LicenseLeaseRead = ResourceWithValidityRead & {
    /** The lease consumption mode, online or offline. */
    mode?: "Online" | "Offline";
    /** The software application version provided in the license consumption request. */
    version?: string;
    anchors?: LicenseLeaseAnchorsRead;
};
export type LicenseLeases = LicenseLease[];
export type LicenseLeasesRead = LicenseLeaseRead[];
export type LicenseSessionAnchor = ResourceBase & ExternalEntityReference;
export type LicenseSessionAnchorRead = ResourceBaseRead & ExternalEntityReference;
export type LicenseSessionAnchors = LicenseSessionAnchor[];
export type LicenseSessionAnchorsRead = LicenseSessionAnchorRead[];
export type LicenseSession = ResourceWithValidity & {
    leases?: LicenseLeases;
    anchors?: LicenseSessionAnchors;
};
export type LicenseSessionRead = ResourceWithValidityRead & {
    leases?: LicenseLeasesRead;
    anchors?: LicenseSessionAnchorsRead;
};
export type LicenseSessions = LicenseSession[];
export type LicenseSessionsRead = LicenseSessionRead[];
export type LicenseAssignmentWithSessions = LicenseAssignment & {
    sessions?: LicenseSessions;
};
export type LicenseAssignmentWithSessionsRead = LicenseAssignmentRead & {
    sessions?: LicenseSessionsRead;
};
export type LicenseAssignmentsWithSessions = LicenseAssignmentWithSessions[];
export type LicenseAssignmentsWithSessionsRead = LicenseAssignmentWithSessionsRead[];
export type UserProfileWithAssignmentsAndSessions = UserProfile & {
    assignments?: LicenseAssignmentsWithSessions;
};
export type UserProfileWithAssignmentsAndSessionsRead = UserProfileRead & {
    assignments?: LicenseAssignmentsWithSessionsRead;
};
export type DeviceClient = LicenseConsumerBase & {
    /** The human-readable name of the device client. */
    name?: string;
};
export type DeviceClientRead = LicenseConsumerBaseRead & {
    /** The human-readable name of the device client. */
    name?: string;
};
export type DeviceClientWithAssignmentsAndSessions = DeviceClient & {
    assignments?: LicenseAssignmentsWithSessions;
};
export type DeviceClientWithAssignmentsAndSessionsRead = DeviceClientRead & {
    assignments?: LicenseAssignmentsWithSessionsRead;
};
export type LicenseUsersWithAssignmentsAndSessions = (({
    objectType: "User";
} & UserProfileWithAssignmentsAndSessions) | ({
    objectType: "DeviceClient";
} & DeviceClientWithAssignmentsAndSessions))[];
export type LicenseUsersWithAssignmentsAndSessionsRead = (({
    objectType: "User";
} & UserProfileWithAssignmentsAndSessionsRead) | ({
    objectType: "DeviceClient";
} & DeviceClientWithAssignmentsAndSessionsRead))[];
export type LicenseUsage = LicenseWithCredits & {
    users?: LicenseUsersWithAssignmentsAndSessions;
};
export type LicenseUsageRead = LicenseWithCreditsRead & {
    users?: LicenseUsersWithAssignmentsAndSessionsRead;
};
export type LicenseAssignments = LicenseAssignment[];
export type LicenseAssignmentsRead = LicenseAssignmentRead[];
export type ResetReservationsResult = {
    assignments?: LicenseAssignments;
    /** One entry per failed release. The key is the ID of the LicenseAssignment and the value is the error. */
    errors?: {
        [key: string]: ApiError;
    };
};
export type ResetReservationsResultRead = {
    assignments?: LicenseAssignmentsRead;
    /** One entry per failed release. The key is the ID of the LicenseAssignment and the value is the error. */
    errors?: {
        [key: string]: ApiError;
    };
};
export type Organization = LicenseeBase & {
    /** The name of the organization. */
    name?: string;
    /** The type of the organization. */
    "type"?: string;
    /** The description of the organization. */
    description?: string;
};
export type OrganizationRead = LicenseeBaseRead & {
    /** The name of the organization. */
    name?: string;
    /** The type of the organization. */
    "type"?: string;
    /** The description of the organization. */
    description?: string;
};
export type LicenseOwner = ({
    objectType: "User";
} & UserProfile) | ({
    objectType: "Organization";
} & Organization);
export type LicenseOwnerRead = ({
    objectType: "User";
} & UserProfileRead) | ({
    objectType: "Organization";
} & OrganizationRead);
export type LicenseWithOwner = LicenseWithCredits & {
    owner?: LicenseOwner;
};
export type LicenseWithOwnerRead = LicenseWithCreditsRead & {
    owner?: LicenseOwnerRead;
};
export type LicenseWithOwnerAndSingleUserAssignments = LicenseWithOwner & {
    assignments?: LicenseAssignments;
};
export type LicenseWithOwnerAndSingleUserAssignmentsRead = LicenseWithOwnerRead & {
    assignments?: LicenseAssignmentsRead;
};
export type LicensesWithOwnerAndSingleUserAssignments = LicenseWithOwnerAndSingleUserAssignments[];
export type LicensesWithOwnerAndSingleUserAssignmentsRead = LicenseWithOwnerAndSingleUserAssignmentsRead[];
export type LicenseWithOwnerAndSingleUserAssignmentsWithSessions = LicenseWithOwner & {
    assignments?: LicenseAssignmentsWithSessions;
};
export type LicenseWithOwnerAndSingleUserAssignmentsWithSessionsRead = LicenseWithOwnerRead & {
    assignments?: LicenseAssignmentsWithSessionsRead;
};
export type LicensesWithOwnerAndSingleUserAssignmentsWithSessions = LicenseWithOwnerAndSingleUserAssignmentsWithSessions[];
export type LicensesWithOwnerAndSingleUserAssignmentsWithSessionsRead = LicenseWithOwnerAndSingleUserAssignmentsWithSessionsRead[];
export type LicenseActivationRequestBase = {
    /** The type of the license activation request. See concrete activation request schema objects such as "ActivationCodeGrantRequest" for supported values. */
    grantType: string;
    /** The IDs of the accepted user agreements (such as EULA or marketing consent). Each ID refers to an actual localized agreement that the user has accepted. */
    acceptLocalizedAgreementIds?: string[];
    /** The IDs of the declined user agreements (such as EULA or marketing consent). Each ID refers to an actual localized agreement that the user has declined. */
    declineLocalizedAgreementIds?: string[];
};
export type ActivationCodeGrantRequest = {
    grantType: "activationCode";
} & LicenseActivationRequestBase & {
    /** The activation code. */
    code?: string;
};
export type LicenseActivationRequest = ActivationCodeGrantRequest;
/**
 * List licensed items of a product package
 */
export function listProductItems(productId: string, opts?: Oazapfts.RequestOpts) {
    return oazapfts.fetchJson<{
        status: 200;
        data: ProductItemsRead;
    } | {
        status: 404;
        data: ApiError;
    } | {
        status: number;
        data: ApiError;
    }>(`/products/${encodeURIComponent(productId)}/product-items`, {
        ...opts
    });
}
/**
 * Get a product package
 */
export function getProduct(productId: string, opts?: Oazapfts.RequestOpts) {
    return oazapfts.fetchJson<{
        status: 200;
        data: ProductRead;
    } | {
        status: 404;
        data: ApiError;
    } | {
        status: number;
        data: ApiError;
    }>(`/products/${encodeURIComponent(productId)}`, {
        ...opts
    });
}
/**
 * List products
 */
export function listProducts({ filter }: {
    filter?: string;
} = {}, opts?: Oazapfts.RequestOpts) {
    return oazapfts.fetchJson<{
        status: 200;
        data: ProductsRead;
    } | {
        status: 404;
        data: ApiError;
    } | {
        status: number;
        data: ApiError;
    }>(`/products${QS.query(QS.explode({
        filter
    }))}`, {
        ...opts
    });
}
/**
 * Provision organization licenses in a transaction
 */
export function processOrganizationLicenseTransaction(orgId: string, licenseTransactionRequest: LicenseTransactionRequest, opts?: Oazapfts.RequestOpts) {
    return oazapfts.fetchJson<{
        status: 200;
        data: LicenseTransactionProcessingResultRead;
    } | {
        status: 409;
        data: ApiError;
    } | {
        status: number;
        data: ApiError;
    }>(`/organizations/${encodeURIComponent(orgId)}/license-transactions`, oazapfts.json({
        ...opts,
        method: "POST",
        body: licenseTransactionRequest
    }));
}
/**
 * Update organization licenses of a transaction
 */
export function updateOrganizationLicenseTransaction(orgId: string, licenseTransactionRequest: LicenseTransactionRequest, { allowDeleteLicenses }: {
    allowDeleteLicenses?: boolean;
} = {}, opts?: Oazapfts.RequestOpts) {
    return oazapfts.fetchJson<{
        status: 200;
        data: LicenseTransactionProcessingResultRead;
    } | {
        status: 404;
        data: ApiError;
    } | {
        status: number;
        data: ApiError;
    }>(`/organizations/${encodeURIComponent(orgId)}/license-transactions${QS.query(QS.explode({
        allowDeleteLicenses
    }))}`, oazapfts.json({
        ...opts,
        method: "PUT",
        body: licenseTransactionRequest
    }));
}
/**
 * Get an organization license transaction
 */
export function getOrganizationLicenseTransaction(orgId: string, transactionExternalId: string, opts?: Oazapfts.RequestOpts) {
    return oazapfts.fetchJson<{
        status: 200;
        data: LicenseTransactionRead;
    } | {
        status: 404;
        data: ApiError;
    } | {
        status: number;
        data: ApiError;
    }>(`/organizations/${encodeURIComponent(orgId)}/license-transactions/${encodeURIComponent(transactionExternalId)}`, {
        ...opts
    });
}
/**
 * Suspend organization licenses of a transaction
 */
export function suspendOrganizationLicenses(orgId: string, transactionExternalId: string, opts?: Oazapfts.RequestOpts) {
    return oazapfts.fetchJson<{
        status: 200;
        data: SuspendLicensesOfTransactionResultRead;
    } | {
        status: 404;
        data: ApiError;
    } | {
        status: number;
        data: ApiError;
    }>(`/organizations/${encodeURIComponent(orgId)}/license-transactions/${encodeURIComponent(transactionExternalId)}/suspend-licenses`, {
        ...opts,
        method: "PUT"
    });
}
/**
 * Resume suspended organization licenses of a transaction
 */
export function resumeOrganizationLicenses(orgId: string, transactionExternalId: string, opts?: Oazapfts.RequestOpts) {
    return oazapfts.fetchJson<{
        status: 200;
        data: ResumeLicensesOfTransactionResultRead;
    } | {
        status: 404;
        data: ApiError;
    } | {
        status: number;
        data: ApiError;
    }>(`/organizations/${encodeURIComponent(orgId)}/license-transactions/${encodeURIComponent(transactionExternalId)}/resume-licenses`, {
        ...opts,
        method: "PUT"
    });
}
/**
 * List an organization's entitlements
 */
export function listOrganizationEntitlements(orgId: string, opts?: Oazapfts.RequestOpts) {
    return oazapfts.fetchJson<{
        status: 200;
        data: EntitlementRead[];
    } | {
        status: 404;
        data: ApiError;
    } | {
        status: number;
        data: ApiError;
    }>(`/organizations/${encodeURIComponent(orgId)}/entitlements`, {
        ...opts
    });
}
/**
 * Create an entitlement for an organization
 */
export function addOrganizationEntitlement(orgId: string, entitlement: Entitlement, opts?: Oazapfts.RequestOpts) {
    return oazapfts.fetchJson<{
        status: 201;
        data: EntitlementRead;
    } | {
        status: 404;
        data: ApiError;
    } | {
        status: 409;
        data: ApiError;
    } | {
        status: number;
        data: ApiError;
    }>(`/organizations/${encodeURIComponent(orgId)}/entitlements`, oazapfts.json({
        ...opts,
        method: "POST",
        body: entitlement
    }));
}
/**
 * Get an organization's entitlement
 */
export function getOrganizationEntitlement(orgId: string, entId: string, opts?: Oazapfts.RequestOpts) {
    return oazapfts.fetchJson<{
        status: 200;
        data: EntitlementRead;
    } | {
        status: 404;
        data: ApiError;
    } | {
        status: number;
        data: ApiError;
    }>(`/organizations/${encodeURIComponent(orgId)}/entitlements/${encodeURIComponent(entId)}`, {
        ...opts
    });
}
/**
 * Update an organization's entitlement
 */
export function updateOrganizationEntitlement(orgId: string, entId: string, entitlement: Entitlement, opts?: Oazapfts.RequestOpts) {
    return oazapfts.fetchJson<{
        status: 200;
        data: EntitlementRead;
    } | {
        status: 403;
        data: ApiError;
    } | {
        status: 404;
        data: ApiError;
    } | {
        status: number;
        data: ApiError;
    }>(`/organizations/${encodeURIComponent(orgId)}/entitlements/${encodeURIComponent(entId)}`, oazapfts.json({
        ...opts,
        method: "PUT",
        body: entitlement
    }));
}
/**
 * Delete an organization's entitlement
 */
export function deleteOrganizationEntitlement(orgId: string, entId: string, { moveLicensesToDefaultEntitlement }: {
    moveLicensesToDefaultEntitlement?: boolean;
} = {}, opts?: Oazapfts.RequestOpts) {
    return oazapfts.fetchJson<{
        status: 204;
    } | {
        status: 403;
        data: ApiError;
    } | {
        status: 404;
        data: ApiError;
    } | {
        status: number;
        data: ApiError;
    }>(`/organizations/${encodeURIComponent(orgId)}/entitlements/${encodeURIComponent(entId)}${QS.query(QS.explode({
        moveLicensesToDefaultEntitlement
    }))}`, {
        ...opts,
        method: "DELETE"
    });
}
/**
 * List user groups with access to an entitlement
 */
export function listLicenseConsumingOrgGroups(orgId: string, entId: string, opts?: Oazapfts.RequestOpts) {
    return oazapfts.fetchJson<{
        status: 200;
        data: OrganizationGroupRead[];
    } | {
        status: 404;
        data: ApiError;
    } | {
        status: number;
        data: ApiError;
    }>(`/organizations/${encodeURIComponent(orgId)}/entitlements/${encodeURIComponent(entId)}/consuming-groups`, {
        ...opts
    });
}
/**
 * Replace user groups that have access to an entitlement
 */
export function setLicenseConsumingOrgGroups(orgId: string, entId: string, body: string[], opts?: Oazapfts.RequestOpts) {
    return oazapfts.fetchJson<{
        status: 201;
    } | {
        status: 404;
        data: ApiError;
    } | {
        status: 409;
        data: ApiError;
    } | {
        status: number;
        data: ApiError;
    }>(`/organizations/${encodeURIComponent(orgId)}/entitlements/${encodeURIComponent(entId)}/consuming-groups`, oazapfts.json({
        ...opts,
        method: "PUT",
        body
    }));
}
/**
 * Grant a user group access to an entitlement
 */
export function addLicenseConsumingOrgGroup(orgId: string, entId: string, groupId: string, opts?: Oazapfts.RequestOpts) {
    return oazapfts.fetchJson<{
        status: 201;
    } | {
        status: 404;
        data: ApiError;
    } | {
        status: 409;
        data: ApiError;
    } | {
        status: number;
        data: ApiError;
    }>(`/organizations/${encodeURIComponent(orgId)}/entitlements/${encodeURIComponent(entId)}/consuming-groups/${encodeURIComponent(groupId)}`, {
        ...opts,
        method: "POST"
    });
}
/**
 * Remove a user group's access to an entitlement
 */
export function removeLicenseConsumingOrgGroup(orgId: string, entId: string, groupId: string, opts?: Oazapfts.RequestOpts) {
    return oazapfts.fetchJson<{
        status: 201;
    } | {
        status: 404;
        data: ApiError;
    } | {
        status: number;
        data: ApiError;
    }>(`/organizations/${encodeURIComponent(orgId)}/entitlements/${encodeURIComponent(entId)}/consuming-groups/${encodeURIComponent(groupId)}`, {
        ...opts,
        method: "DELETE"
    });
}
/**
 * Get IDs of users with access to an entitlement
 */
export function listEntitlementConsumingUsers(orgId: string, entId: string, opts?: Oazapfts.RequestOpts) {
    return oazapfts.fetchJson<{
        status: 200;
        data: ObjectIds;
    } | {
        status: 404;
        data: ApiError;
    } | {
        status: number;
        data: ApiError;
    }>(`/organizations/${encodeURIComponent(orgId)}/entitlements/${encodeURIComponent(entId)}/consuming-users`, {
        ...opts
    });
}
/**
 * Grant a user group access to an entitlement
 */
export function addEntitlementConsumedByOrgGroup(orgId: string, entId: string, groupId: string, opts?: Oazapfts.RequestOpts) {
    return oazapfts.fetchJson<{
        status: 201;
    } | {
        status: 404;
        data: ApiError;
    } | {
        status: 409;
        data: ApiError;
    } | {
        status: number;
        data: ApiError;
    }>(`/organizations/${encodeURIComponent(orgId)}/groups/${encodeURIComponent(groupId)}/consumed-entitlements/${encodeURIComponent(entId)}`, {
        ...opts,
        method: "POST"
    });
}
/**
 * Remove a user group's access to an entitlement
 */
export function removeEntitlementConsumedByOrgGroup(orgId: string, entId: string, groupId: string, opts?: Oazapfts.RequestOpts) {
    return oazapfts.fetchJson<{
        status: 201;
    } | {
        status: 404;
        data: ApiError;
    } | {
        status: number;
        data: ApiError;
    }>(`/organizations/${encodeURIComponent(orgId)}/groups/${encodeURIComponent(groupId)}/consumed-entitlements/${encodeURIComponent(entId)}`, {
        ...opts,
        method: "DELETE"
    });
}
/**
 * List client groups with access to an entitlement
 */
export function listLicenseConsumingCliGroups(orgId: string, entId: string, opts?: Oazapfts.RequestOpts) {
    return oazapfts.fetchJson<{
        status: 200;
        data: ClientGroupRead[];
    } | {
        status: 404;
        data: ApiError;
    } | {
        status: number;
        data: ApiError;
    }>(`/organizations/${encodeURIComponent(orgId)}/entitlements/${encodeURIComponent(entId)}/consuming-client-groups`, {
        ...opts
    });
}
/**
 * Replace client groups that have access to an entitlement
 */
export function setLicenseConsumingCliGroups(orgId: string, entId: string, body: string[], opts?: Oazapfts.RequestOpts) {
    return oazapfts.fetchJson<{
        status: 201;
    } | {
        status: 404;
        data: ApiError;
    } | {
        status: 409;
        data: ApiError;
    } | {
        status: number;
        data: ApiError;
    }>(`/organizations/${encodeURIComponent(orgId)}/entitlements/${encodeURIComponent(entId)}/consuming-client-groups`, oazapfts.json({
        ...opts,
        method: "PUT",
        body
    }));
}
/**
 * Grant a client group access to an entitlement
 */
export function addLicenseConsumingCliGroup(orgId: string, entId: string, groupId: string, opts?: Oazapfts.RequestOpts) {
    return oazapfts.fetchJson<{
        status: 201;
    } | {
        status: 404;
        data: ApiError;
    } | {
        status: 409;
        data: ApiError;
    } | {
        status: number;
        data: ApiError;
    }>(`/organizations/${encodeURIComponent(orgId)}/entitlements/${encodeURIComponent(entId)}/consuming-client-groups/${encodeURIComponent(groupId)}`, {
        ...opts,
        method: "POST"
    });
}
/**
 * Remove a client group's access to an entitlement
 */
export function removeLicenseConsumingCliGroup(orgId: string, entId: string, groupId: string, opts?: Oazapfts.RequestOpts) {
    return oazapfts.fetchJson<{
        status: 201;
    } | {
        status: 404;
        data: ApiError;
    } | {
        status: number;
        data: ApiError;
    }>(`/organizations/${encodeURIComponent(orgId)}/entitlements/${encodeURIComponent(entId)}/consuming-client-groups/${encodeURIComponent(groupId)}`, {
        ...opts,
        method: "DELETE"
    });
}
/**
 * Get IDs of clients with access to an entitlement
 */
export function listEntitlementConsumingClients(orgId: string, entId: string, opts?: Oazapfts.RequestOpts) {
    return oazapfts.fetchJson<{
        status: 200;
        data: ObjectIds;
    } | {
        status: 404;
        data: ApiError;
    } | {
        status: number;
        data: ApiError;
    }>(`/organizations/${encodeURIComponent(orgId)}/entitlements/${encodeURIComponent(entId)}/consuming-clients`, {
        ...opts
    });
}
/**
 * List entitlements a user group has access to
 */
export function listEntitlementsConsumedByOrgGroup(orgId: string, groupId: string, opts?: Oazapfts.RequestOpts) {
    return oazapfts.fetchJson<{
        status: 200;
        data: EntitlementRead[];
    } | {
        status: 404;
        data: ApiError;
    } | {
        status: number;
        data: ApiError;
    }>(`/organizations/${encodeURIComponent(orgId)}/groups/${encodeURIComponent(groupId)}/consumed-entitlements`, {
        ...opts
    });
}
/**
 * Replace entitlements a user group has access to
 */
export function setEntitlementsConsumedByOrgGroup(orgId: string, groupId: string, body: string[], opts?: Oazapfts.RequestOpts) {
    return oazapfts.fetchJson<{
        status: 201;
    } | {
        status: 404;
        data: ApiError;
    } | {
        status: 409;
        data: ApiError;
    } | {
        status: number;
        data: ApiError;
    }>(`/organizations/${encodeURIComponent(orgId)}/groups/${encodeURIComponent(groupId)}/consumed-entitlements`, oazapfts.json({
        ...opts,
        method: "PUT",
        body
    }));
}
/**
 * List entitlements a client group has access to
 */
export function listEntitlementsConsumedByCliGroup(orgId: string, groupId: string, opts?: Oazapfts.RequestOpts) {
    return oazapfts.fetchJson<{
        status: 200;
        data: EntitlementRead[];
    } | {
        status: 404;
        data: ApiError;
    } | {
        status: number;
        data: ApiError;
    }>(`/organizations/${encodeURIComponent(orgId)}/client-groups/${encodeURIComponent(groupId)}/consumed-entitlements`, {
        ...opts
    });
}
/**
 * Replace entitlements a client group has access to
 */
export function setEntitlementsConsumedByCliGroup(orgId: string, groupId: string, body: string[], opts?: Oazapfts.RequestOpts) {
    return oazapfts.fetchJson<{
        status: 201;
    } | {
        status: 404;
        data: ApiError;
    } | {
        status: 409;
        data: ApiError;
    } | {
        status: number;
        data: ApiError;
    }>(`/organizations/${encodeURIComponent(orgId)}/client-groups/${encodeURIComponent(groupId)}/consumed-entitlements`, oazapfts.json({
        ...opts,
        method: "PUT",
        body
    }));
}
/**
 * Grant a client group access to an entitlement
 */
export function addEntitlementConsumedByCliGroup(orgId: string, entId: string, groupId: string, opts?: Oazapfts.RequestOpts) {
    return oazapfts.fetchJson<{
        status: 201;
    } | {
        status: 404;
        data: ApiError;
    } | {
        status: 409;
        data: ApiError;
    } | {
        status: number;
        data: ApiError;
    }>(`/organizations/${encodeURIComponent(orgId)}/client-groups/${encodeURIComponent(groupId)}/consumed-entitlements/${encodeURIComponent(entId)}`, {
        ...opts,
        method: "POST"
    });
}
/**
 * Remove a client group's access to an entitlement
 */
export function removeEntitlementConsumedByCliGroup(orgId: string, entId: string, groupId: string, opts?: Oazapfts.RequestOpts) {
    return oazapfts.fetchJson<{
        status: 201;
    } | {
        status: 404;
        data: ApiError;
    } | {
        status: number;
        data: ApiError;
    }>(`/organizations/${encodeURIComponent(orgId)}/client-groups/${encodeURIComponent(groupId)}/consumed-entitlements/${encodeURIComponent(entId)}`, {
        ...opts,
        method: "DELETE"
    });
}
/**
 * List an organization's licenses
 */
export function listEntitlementLicenses(orgId: string, entId: string, { includeEffectiveModel }: {
    includeEffectiveModel?: boolean;
} = {}, opts?: Oazapfts.RequestOpts) {
    return oazapfts.fetchJson<{
        status: 200;
        data: LicensesWithCreditsRead;
    } | {
        status: 404;
        data: ApiError;
    } | {
        status: number;
        data: ApiError;
    }>(`/organizations/${encodeURIComponent(orgId)}/entitlements/${encodeURIComponent(entId)}/licenses${QS.query(QS.explode({
        includeEffectiveModel
    }))}`, {
        ...opts
    });
}
/**
 * Get current usage of a license
 */
export function queryLicenseUsage(orgId: string, entId: string, licenseId: string, { includeEffectiveModel }: {
    includeEffectiveModel?: boolean;
} = {}, opts?: Oazapfts.RequestOpts) {
    return oazapfts.fetchJson<{
        status: 200;
        data: LicenseUsageRead;
    } | {
        status: 404;
        data: ApiError;
    } | {
        status: number;
        data: ApiError;
    }>(`/organizations/${encodeURIComponent(orgId)}/entitlements/${encodeURIComponent(entId)}/licenses/${encodeURIComponent(licenseId)}/usage${QS.query(QS.explode({
        includeEffectiveModel
    }))}`, {
        ...opts
    });
}
/**
 * Get a client's assignments for a license
 */
export function getClientLicenseAssignments(orgId: string, entId: string, licenseId: string, clientId: string, opts?: Oazapfts.RequestOpts) {
    return oazapfts.fetchJson<{
        status: 200;
        data: LicenseAssignmentsRead;
    } | {
        status: 404;
        data: ApiError;
    } | {
        status: number;
        data: ApiError;
    }>(`/organizations/${encodeURIComponent(orgId)}/entitlements/${encodeURIComponent(entId)}/licenses/${encodeURIComponent(licenseId)}/clients/${encodeURIComponent(clientId)}/assignments`, {
        ...opts
    });
}
/**
 * Manage a client's assignments for a license
 */
export function manageClientLicenseAssignments(orgId: string, entId: string, licenseId: string, clientId: string, licenseAssignments: LicenseAssignments, opts?: Oazapfts.RequestOpts) {
    return oazapfts.fetchJson<{
        status: 200;
        data: LicenseAssignmentsRead;
    } | {
        status: 404;
        data: ApiError;
    } | {
        status: number;
        data: ApiError;
    }>(`/organizations/${encodeURIComponent(orgId)}/entitlements/${encodeURIComponent(entId)}/licenses/${encodeURIComponent(licenseId)}/clients/${encodeURIComponent(clientId)}/assignments`, oazapfts.json({
        ...opts,
        method: "PUT",
        body: licenseAssignments
    }));
}
/**
 * Block a license for a client
 */
export function denyLicenseForClient(orgId: string, entId: string, licenseId: string, clientId: string, opts?: Oazapfts.RequestOpts) {
    return oazapfts.fetchJson<{
        status: 200;
        data: LicenseAssignmentsRead;
    } | {
        status: 400;
        data: ApiError;
    } | {
        status: 404;
        data: ApiError;
    } | {
        status: number;
        data: ApiError;
    }>(`/organizations/${encodeURIComponent(orgId)}/entitlements/${encodeURIComponent(entId)}/licenses/${encodeURIComponent(licenseId)}/clients/${encodeURIComponent(clientId)}/deny`, {
        ...opts,
        method: "PUT"
    });
}
/**
 * Reserve a license seat for a client
 */
export function reserveLicenseForClient(orgId: string, entId: string, licenseId: string, clientId: string, opts?: Oazapfts.RequestOpts) {
    return oazapfts.fetchJson<{
        status: 200;
        data: LicenseAssignmentsRead;
    } | {
        status: 400;
        data: ApiError;
    } | {
        status: 404;
        data: ApiError;
    } | {
        status: number;
        data: ApiError;
    }>(`/organizations/${encodeURIComponent(orgId)}/entitlements/${encodeURIComponent(entId)}/licenses/${encodeURIComponent(licenseId)}/clients/${encodeURIComponent(clientId)}/reserve`, {
        ...opts,
        method: "PUT"
    });
}
/**
 * Reset a client's assignments for a license
 */
export function resetReservationsAndDenialsForClient(orgId: string, entId: string, licenseId: string, clientId: string, opts?: Oazapfts.RequestOpts) {
    return oazapfts.fetchJson<{
        status: 200;
        data: ResetReservationsResultRead;
    } | {
        status: 400;
        data: ApiError;
    } | {
        status: 404;
        data: ApiError;
    } | {
        status: number;
        data: ApiError;
    }>(`/organizations/${encodeURIComponent(orgId)}/entitlements/${encodeURIComponent(entId)}/licenses/${encodeURIComponent(licenseId)}/clients/${encodeURIComponent(clientId)}/reset`, {
        ...opts,
        method: "PUT"
    });
}
/**
 * Get a user's assignments for a license
 */
export function getLicenseAssignments(orgId: string, entId: string, licenseId: string, userId: string, opts?: Oazapfts.RequestOpts) {
    return oazapfts.fetchJson<{
        status: 200;
        data: LicenseAssignmentsRead;
    } | {
        status: 404;
        data: ApiError;
    } | {
        status: number;
        data: ApiError;
    }>(`/organizations/${encodeURIComponent(orgId)}/entitlements/${encodeURIComponent(entId)}/licenses/${encodeURIComponent(licenseId)}/users/${encodeURIComponent(userId)}/assignments`, {
        ...opts
    });
}
/**
 * Manage a user's assignments for a license
 */
export function manageLicenseAssignments(orgId: string, entId: string, licenseId: string, userId: string, licenseAssignments: LicenseAssignments, opts?: Oazapfts.RequestOpts) {
    return oazapfts.fetchJson<{
        status: 200;
        data: LicenseAssignmentsRead;
    } | {
        status: 404;
        data: ApiError;
    } | {
        status: number;
        data: ApiError;
    }>(`/organizations/${encodeURIComponent(orgId)}/entitlements/${encodeURIComponent(entId)}/licenses/${encodeURIComponent(licenseId)}/users/${encodeURIComponent(userId)}/assignments`, oazapfts.json({
        ...opts,
        method: "PUT",
        body: licenseAssignments
    }));
}
/**
 * Block a license for a user
 */
export function denyLicenseForUser(orgId: string, entId: string, licenseId: string, userId: string, opts?: Oazapfts.RequestOpts) {
    return oazapfts.fetchJson<{
        status: 200;
        data: LicenseAssignmentsRead;
    } | {
        status: 400;
        data: ApiError;
    } | {
        status: 404;
        data: ApiError;
    } | {
        status: number;
        data: ApiError;
    }>(`/organizations/${encodeURIComponent(orgId)}/entitlements/${encodeURIComponent(entId)}/licenses/${encodeURIComponent(licenseId)}/users/${encodeURIComponent(userId)}/deny`, {
        ...opts,
        method: "PUT"
    });
}
/**
 * Reserve a license seat for a user
 */
export function reserveLicenseForUser(orgId: string, entId: string, licenseId: string, userId: string, opts?: Oazapfts.RequestOpts) {
    return oazapfts.fetchJson<{
        status: 200;
        data: LicenseAssignmentsRead;
    } | {
        status: 400;
        data: ApiError;
    } | {
        status: 404;
        data: ApiError;
    } | {
        status: number;
        data: ApiError;
    }>(`/organizations/${encodeURIComponent(orgId)}/entitlements/${encodeURIComponent(entId)}/licenses/${encodeURIComponent(licenseId)}/users/${encodeURIComponent(userId)}/reserve`, {
        ...opts,
        method: "PUT"
    });
}
/**
 * Reset a user's assignments for a license
 */
export function resetReservationsAndDenialsForUser(orgId: string, entId: string, licenseId: string, userId: string, opts?: Oazapfts.RequestOpts) {
    return oazapfts.fetchJson<{
        status: 200;
        data: ResetReservationsResultRead;
    } | {
        status: 400;
        data: ApiError;
    } | {
        status: 404;
        data: ApiError;
    } | {
        status: number;
        data: ApiError;
    }>(`/organizations/${encodeURIComponent(orgId)}/entitlements/${encodeURIComponent(entId)}/licenses/${encodeURIComponent(licenseId)}/users/${encodeURIComponent(userId)}/reset`, {
        ...opts,
        method: "PUT"
    });
}
/**
 * Get licenses available to a user
 */
export function queryAvailableLicenses(userId: string, { licensedItemName, ownerOrganizationId, includeEffectiveModel, includeAggregatedLicensedItems, onlyValidLicenses }: {
    licensedItemName?: string;
    ownerOrganizationId?: string;
    includeEffectiveModel?: boolean;
    includeAggregatedLicensedItems?: boolean;
    onlyValidLicenses?: boolean;
} = {}, opts?: Oazapfts.RequestOpts) {
    return oazapfts.fetchJson<{
        status: 200;
        data: LicensesWithOwnerAndSingleUserAssignmentsRead;
    } | {
        status: 404;
        data: ApiError;
    } | {
        status: number;
        data: ApiError;
    }>(`/users/${encodeURIComponent(userId)}/available-licenses${QS.query(QS.explode({
        licensedItemName,
        ownerOrganizationId,
        includeEffectiveModel,
        includeAggregatedLicensedItems,
        onlyValidLicenses
    }))}`, {
        ...opts
    });
}
/**
 * Get licenses in use by a user
 */
export function queryUserLicenseUsage(userId: string, { includeEffectiveModel, includeAggregatedLicensedItems }: {
    includeEffectiveModel?: boolean;
    includeAggregatedLicensedItems?: boolean;
} = {}, opts?: Oazapfts.RequestOpts) {
    return oazapfts.fetchJson<{
        status: 200;
        data: LicensesWithOwnerAndSingleUserAssignmentsWithSessionsRead;
    } | {
        status: 404;
        data: ApiError;
    } | {
        status: number;
        data: ApiError;
    }>(`/users/${encodeURIComponent(userId)}/license-usage${QS.query(QS.explode({
        includeEffectiveModel,
        includeAggregatedLicensedItems
    }))}`, {
        ...opts
    });
}
/**
 * Provision user licenses with an activation code
 */
export function activateUserLicenses(userId: string, licenseActivationRequest: LicenseActivationRequest, opts?: Oazapfts.RequestOpts) {
    return oazapfts.fetchJson<{
        status: 200;
        data: LicenseTransactionProcessingResultRead;
    } | {
        status: number;
        data: ApiError;
    }>(`/users/${encodeURIComponent(userId)}/activate-licenses`, oazapfts.json({
        ...opts,
        method: "POST",
        body: licenseActivationRequest
    }));
}
/**
 * Provision user licenses in a transaction
 */
export function processUserLicenseTransaction(userId: string, licenseTransactionRequest: LicenseTransactionRequest, opts?: Oazapfts.RequestOpts) {
    return oazapfts.fetchJson<{
        status: 200;
        data: LicenseTransactionProcessingResultRead;
    } | {
        status: 409;
        data: ApiError;
    } | {
        status: number;
        data: ApiError;
    }>(`/users/${encodeURIComponent(userId)}/license-transactions`, oazapfts.json({
        ...opts,
        method: "POST",
        body: licenseTransactionRequest
    }));
}
/**
 * Update user licenses of a transaction
 */
export function updateUserLicenseTransaction(userId: string, licenseTransactionRequest: LicenseTransactionRequest, { allowDeleteLicenses }: {
    allowDeleteLicenses?: boolean;
} = {}, opts?: Oazapfts.RequestOpts) {
    return oazapfts.fetchJson<{
        status: 200;
        data: LicenseTransactionProcessingResultRead;
    } | {
        status: 404;
        data: ApiError;
    } | {
        status: number;
        data: ApiError;
    }>(`/users/${encodeURIComponent(userId)}/license-transactions${QS.query(QS.explode({
        allowDeleteLicenses
    }))}`, oazapfts.json({
        ...opts,
        method: "PUT",
        body: licenseTransactionRequest
    }));
}
/**
 * Get a user license transaction
 */
export function getUserLicenseTransaction(userId: string, transactionExternalId: string, opts?: Oazapfts.RequestOpts) {
    return oazapfts.fetchJson<{
        status: 200;
        data: LicenseTransactionRead;
    } | {
        status: 404;
        data: ApiError;
    } | {
        status: number;
        data: ApiError;
    }>(`/users/${encodeURIComponent(userId)}/license-transactions/${encodeURIComponent(transactionExternalId)}`, {
        ...opts
    });
}
/**
 * Suspend user licenses of a transaction
 */
export function suspendUserLicenses(userId: string, transactionExternalId: string, opts?: Oazapfts.RequestOpts) {
    return oazapfts.fetchJson<{
        status: 200;
        data: SuspendLicensesOfTransactionResultRead;
    } | {
        status: 404;
        data: ApiError;
    } | {
        status: number;
        data: ApiError;
    }>(`/users/${encodeURIComponent(userId)}/license-transactions/${encodeURIComponent(transactionExternalId)}/suspend-licenses`, {
        ...opts,
        method: "PUT"
    });
}
/**
 * Resume suspended user licenses of a transaction
 */
export function resumeUserLicenses(userId: string, transactionExternalId: string, opts?: Oazapfts.RequestOpts) {
    return oazapfts.fetchJson<{
        status: 200;
        data: ResumeLicensesOfTransactionResultRead;
    } | {
        status: 404;
        data: ApiError;
    } | {
        status: number;
        data: ApiError;
    }>(`/users/${encodeURIComponent(userId)}/license-transactions/${encodeURIComponent(transactionExternalId)}/resume-licenses`, {
        ...opts,
        method: "PUT"
    });
}
/**
 * Get licenses available to a client
 */
export function queryClientAvailableLicenses(clientId: string, { licensedItemName, ownerOrganizationId, includeEffectiveModel, includeAggregatedLicensedItems, onlyValidLicenses }: {
    licensedItemName?: string;
    ownerOrganizationId?: string;
    includeEffectiveModel?: boolean;
    includeAggregatedLicensedItems?: boolean;
    onlyValidLicenses?: boolean;
} = {}, opts?: Oazapfts.RequestOpts) {
    return oazapfts.fetchJson<{
        status: 200;
        data: LicensesWithOwnerAndSingleUserAssignmentsRead;
    } | {
        status: 404;
        data: ApiError;
    } | {
        status: number;
        data: ApiError;
    }>(`/clients/${encodeURIComponent(clientId)}/available-licenses${QS.query(QS.explode({
        licensedItemName,
        ownerOrganizationId,
        includeEffectiveModel,
        includeAggregatedLicensedItems,
        onlyValidLicenses
    }))}`, {
        ...opts
    });
}
/**
 * Get licenses in use by a client
 */
export function queryClientLicenseUsage(clientId: string, { includeEffectiveModel, includeAggregatedLicensedItems }: {
    includeEffectiveModel?: boolean;
    includeAggregatedLicensedItems?: boolean;
} = {}, opts?: Oazapfts.RequestOpts) {
    return oazapfts.fetchJson<{
        status: 200;
        data: LicensesWithOwnerAndSingleUserAssignmentsWithSessionsRead;
    } | {
        status: 404;
        data: ApiError;
    } | {
        status: number;
        data: ApiError;
    }>(`/clients/${encodeURIComponent(clientId)}/license-usage${QS.query(QS.explode({
        includeEffectiveModel,
        includeAggregatedLicensedItems
    }))}`, {
        ...opts
    });
}
/**
 * Provision organization licenses with an activation code
 */
export function activateOrganizationLicenses(orgId: string, licenseActivationRequest: LicenseActivationRequest, opts?: Oazapfts.RequestOpts) {
    return oazapfts.fetchJson<{
        status: 200;
        data: LicenseTransactionProcessingResultRead;
    } | {
        status: number;
        data: ApiError;
    }>(`/organizations/${encodeURIComponent(orgId)}/activate-licenses`, oazapfts.json({
        ...opts,
        method: "POST",
        body: licenseActivationRequest
    }));
}
/**
 * Move a license
 */
export function moveLicense(orgId: string, entId: string, licenseId: string, destEntId: string, { includeEffectiveModel }: {
    includeEffectiveModel?: boolean;
} = {}, opts?: Oazapfts.RequestOpts) {
    return oazapfts.fetchJson<{
        status: 200;
        data: LicenseWithCreditsRead;
    } | {
        status: 404;
        data: ApiError;
    } | {
        status: 409;
        data: ApiError;
    } | {
        status: number;
        data: ApiError;
    }>(`/organizations/${encodeURIComponent(orgId)}/entitlements/${encodeURIComponent(entId)}/licenses/${encodeURIComponent(licenseId)}/move/${encodeURIComponent(destEntId)}${QS.query(QS.explode({
        includeEffectiveModel
    }))}`, {
        ...opts,
        method: "PUT"
    });
}
